import { render } from "./GamelistTable.vue?vue&type=template&id=63d966b2&scoped=true"
import script from "./GamelistTable.vue?vue&type=script&lang=js"
export * from "./GamelistTable.vue?vue&type=script&lang=js"

import "./GamelistTable.vue?vue&type=style&index=0&id=63d966b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d966b2"]])

export default __exports__